<div class="dialog" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div fxLayout="row" fxLayoutGap="10px">
        <mat-icon>create</mat-icon>
        <h1 *ngIf="!isAdded">{{'アンケート結果 ダウンロードファイル：編集' | translate}}</h1>
        <h1 *ngIf="!!isAdded">{{'アンケート結果 ダウンロードファイル：作成' | translate}}</h1>
      </div>

      <div fxLayout="row" fxLayoutGap="10px">
        <button mat-raised-button color="primary" (click)="create()" [disabled]="!enqueteFormGroup.valid">
          <mat-icon>add</mat-icon>
          <span *ngIf="!isAdded">{{'更新' | translate}}</span>
          <span *ngIf="!!isAdded">{{'作成' | translate}}</span>
        </button>
        <button mat-button (click)="onNoClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div mat-dialog-content>
    <form class="form" [formGroup]="enqueteFormGroup">
      <div class="dialog-body" fxLayout="column" fxLayoutGap="24px">

        <div>
          <mat-form-field fxFlex>
            <mat-label floatLabel="always">{{'メモ' | translate}}</mat-label>
            <input matInput placeholder="{{'メモ' | translate}}" id="memo" formControlName="memo">
          </mat-form-field>
        </div>

        <div>
          <mat-form-field fxFlex>
            <mat-label floatLabel="always">{{'設問セット' | translate}}</mat-label>
            <mat-select placeholder="{{'設問セット' | translate}}" id="questSetId" formControlName="questSetId" [disabled]="!isAdded">
              <mat-option *ngFor="let questSet of (questSets | async)" [value]="questSet.id">
                <div fxLayout="row" fxLayoutAlign="space-between end">
                  <span>{{ questSet.id }}</span>
                  <span>&nbsp;&nbsp;&nbsp;</span>
                  <span>{{ questSet.name }}</span>
                </div>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutGap="20px">
          <mat-form-field fxFlex="50%">
            <mat-label>{{'作成期間(開始日時)' | translate}}</mat-label>
            <input matInput [ngxMatDatetimePicker]="startDatePicker" placeholder="{{'作成期間(開始日時)' | translate}}" formControlName="startDate" readonly>
            <mat-datepicker-toggle *ngIf="!!isAdded" matSuffix [for]="$any(startDatePicker)"></mat-datepicker-toggle>
            <ngx-mat-datetime-picker #startDatePicker [showSeconds]=true
              [defaultTime]="[0, 0, 0]"></ngx-mat-datetime-picker>
          </mat-form-field>
          <mat-form-field fxFlex="50%">
            <mat-label>{{'作成期間(終了日時)' | translate}}</mat-label>
            <input matInput [ngxMatDatetimePicker]="endDatePicker" placeholder="{{'作成期間(終了日時)' | translate}}" formControlName="endDate" readonly>
            <mat-datepicker-toggle *ngIf="!!isAdded" matSuffix [for]="$any(endDatePicker)"></mat-datepicker-toggle>
            <ngx-mat-datetime-picker #endDatePicker [showSeconds]=true
              [defaultTime]="[23, 59, 59]"></ngx-mat-datetime-picker>
            <mat-error *ngIf="endDateControl.hasError('before_start_date')">{{ getErrorMessageToEndDate() }}</mat-error>
          </mat-form-field>
        </div>

      </div>
    </form>
  </div>


</div>